import { fetchClient, publicRqClient } from "../../shared/api/instance";
import { useQuery } from "@tanstack/react-query";

export function useGetPaymentItems(
  { type, partnerId, region, city },
  { enabled }
) {
  const { data, isLoading } = useQuery({
    queryKey: ["payment-items", region, city, partnerId, type],
    queryFn: async ({ pageParam = 0 }) => {
      const res = await fetchClient.GET("/payments/v1/items", {
        params: {
          query: {
            type,
            partnerId,
            region,
            city,
          },
        },
      });
      return res.data?.data || [];
    },
    enabled, //: true, //false
  });

  return {
    items: data,
    isLoading,
  };
}

export function useGetPaymentItemsPublic(
  { type, partnerId, region, city },
  { enabled }
) {
  return publicRqClient.useQuery(
    "get",
    "/payments/v1/items",
    {
      params: {
        query: {
          type,
          partnerId,
          region,
          city,
        },
      },
    },
    {
      enabled,
    }
  );
}
